import React from 'react';
import { FormattedMessage } from 'react-intl';

import { RangeValue } from '@/features/brakes/hooks/useBrakesQueryParams';
import CriticalityFilter, { Criticality } from '@/features/common/components/CriticalityFilter';
import RangeInputWithSlider from '@/features/common/components/RangeInputWithSlider';

interface BrakeLiningFiltersProps {
    minValue: number;
    maxValue: number;
    onRangeChange: (range: RangeValue) => void;
    criticalityStatus: Criticality[];
    onCriticalityChange: (status: Criticality[]) => void;
    isLoading: boolean;
}

const getCriticalityFilterOptions = (selectedItems: Criticality[]) => [
    {
        id: Criticality.CRITICAL,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.critical" />,
        icon: <span className="rioglyph rioglyph-error-sign text-size-16 text-color-danger" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Criticality.CRITICAL),
    },
    {
        id: Criticality.WARNING,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.warning" />,
        icon: <span className="rioglyph rioglyph-warning-sign text-size-16 text-color-warning" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Criticality.WARNING),
    },
    {
        id: Criticality.OK,
        label: <FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.ok" />,
        icon: <span className="rioglyph rioglyph-ok text-size-16 text-normal" />,
        selected: selectedItems.length === 0 || selectedItems.includes(Criticality.OK),
    },
];

const BrakeLiningFilters = ({
    minValue,
    maxValue,
    onRangeChange,
    criticalityStatus,
    onCriticalityChange,
    isLoading,
}: BrakeLiningFiltersProps) => {
    return (
        <div className="display-flex flex-row gap-20 align-items-end">
            <RangeInputWithSlider
                max={100}
                min={0}
                range={{ from: minValue, to: maxValue }}
                title="intl-msg:vehicle-diagnostics.maintenance.table.brakes.filter.title"
                onRangeChange={onRangeChange}
                unit={'%'}
            />
            <CriticalityFilter
                isLoading={isLoading}
                title={<FormattedMessage id="intl-msg:vehicle_diagnostics.filters.criticality.title" />}
                placeholder=""
                filterOptions={getCriticalityFilterOptions(criticalityStatus)}
                onSelect={onCriticalityChange}
            />
        </div>
    );
};

export default BrakeLiningFilters;
